"use client";
import * as m from "react";
import { u as p } from "./useIsoLayoutEffect-DpJo20by.mjs";
import { u as c, f as b } from "./FieldRootContext-Cj7-dNhd.mjs";
import { u as F } from "./useBaseUiId-a-UPSsPQ.mjs";
import { u as E } from "./useRenderElement-B8V3_e8R.mjs";
import { g as I } from "./element-DE7VsBMX.mjs";
const L = /* @__PURE__ */ m.forwardRef(function(a, n) {
  const {
    render: y,
    className: N,
    id: t,
    ...l
  } = a, {
    labelId: d,
    setLabelId: o,
    state: u,
    controlId: s
  } = c(!1), i = F(t), f = s ?? void 0;
  return p(() => ((s != null || t) && o(i), () => {
    o(void 0);
  }), [s, i, t, o]), E("label", a, {
    ref: n,
    state: u,
    props: [{
      id: d,
      htmlFor: f,
      onMouseDown(e) {
        const r = I(e.nativeEvent);
        r != null && r.closest("button,input,select,textarea") || !e.defaultPrevented && e.detail > 1 && e.preventDefault();
      }
    }, l],
    customStyleHookMapping: b
  });
});
process.env.NODE_ENV !== "production" && (L.displayName = "FieldLabel");
export {
  L as F
};
